import React from 'react';
import TextField from '@material-ui/core/TextField';
import withStyles from '@material-ui/core/styles/withStyles';
import variables from '../../styles/variables.module.scss';

const styles = {
  root: {
    backgroundColor: 'transparent !important',
    '& p': {
      color: variables.springGreen,
    },
  },
  rootInput: {
    backgroundColor: '#2b2e33 !important',
    borderRadius: 0,
    color: variables.cleanWhite,
    borderBottom: `2px solid ${variables.springGreen} !important`,
  },
  input: {
    WebkitBoxShadow:
      '0 0 0 1000px #2b2e33 inset !important',
    '&::placeholder': {
      opacity: 1,
      textOverflow: 'ellipsis !important',
      color: `${variables.springGreen} !important`,
    },
  },
  label: {
    color: variables.springGreen,
  },
  focusedLabel: {
    color: `${variables.springGreen} !important`,
  },
};

const DefaultTextField = ({
  classes,
  pattern,
  ...props
}) => (
  <TextField
    {...props}
    variant="filled"
    className={classes.root}
    InputProps={{
      classes: {
        root: classes.rootInput,
        input: classes.input,
      },
      disableUnderline: true,
      pattern,
    }}
    InputLabelProps={{
      classes: {
        root: classes.label,
        focused: classes.focusedLabel,
      },
    }}
  />
);

export default withStyles(styles)(DefaultTextField);
